import React from 'react'

import type Immutable from 'immutable'

import { Section } from '../Section'
import { ReferAFriend } from './ReferAFriend'

type ReferAFriendWrapperProps = {
  userGetReferralDetails: () => void
  referralDetails?: Immutable.Map<string, any>
  redirect: (path: string) => void
}

export class ReferAFriendWrapper extends React.PureComponent<ReferAFriendWrapperProps> {
  componentDidMount(): void {
    const { userGetReferralDetails } = this.props

    userGetReferralDetails()
  }

  render(): React.ReactElement {
    const { referralDetails, redirect } = this.props

    return (
      <Section title="Your Gousto wins" alternateColour>
        <ReferAFriend referralDetails={referralDetails} redirect={redirect} />
      </Section>
    )
  }
}
